import apiClient from './api'
import type {
  ApiResponse,
  AccountDeletionRequest,
  PrivacyPolicy,
  Consent,
  ConsentRequest,
  CookieConfig,
} from '@/types'

// 1:1 with Schema_Specification Section 4.12 (compliance — /compliance/*).
export const complianceApi = {
  // 2.13.1 account deletion
  requestAccountDeletion: (body: AccountDeletionRequest) =>
    apiClient
      .post<
        ApiResponse<AccountDeletionRequest>
      >('/compliance/account-deletion', body)
      .then(r => r.data),

  // 2.13.2 privacy policy & consent
  getPrivacyPolicy: () =>
    apiClient
      .get<ApiResponse<PrivacyPolicy>>('/compliance/privacy-policy')
      .then(r => r.data),
  recordConsent: (body: ConsentRequest) =>
    apiClient
      .post<ApiResponse<Consent>>('/compliance/consent', body)
      .then(r => r.data),

  // 2.13.4 cookie consent
  getCookieConfig: () =>
    apiClient
      .get<ApiResponse<CookieConfig>>('/compliance/cookie-config')
      .then(r => r.data),
  recordCookieConsent: (body: ConsentRequest) =>
    apiClient
      .post<ApiResponse<Consent>>('/compliance/cookie-consent', body)
      .then(r => r.data),
}

export default complianceApi
